import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/elanwave.webp';
import screenshot_target from '../../../images/letterfunnel/dejandujak.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Dejan Dujak"
      firstname="Dejan"
      companyname="ElanWave"
      competition="Levi9 en Motion10"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/dejandujak.js